import { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { useQueryParams } from '../router/useQueryParams';
import AuthContainer from '../containers/AuthContainer';
import { DEPRECATE_LEGACY_TIMELINE } from '../constants/gates';
import { useOnCrmMessageTopic } from 'crm-message-bus/useOnCrmMessageTopic';
export function useEngagementDeepLink(subjectId, objectTypeId) {
  const history = useHistory();
  const query = useQueryParams();
  const isEngagementDeepLink = !!query.engagement;
  const auth = AuthContainer.get();
  const gates = auth.gates;
  const sendOpenActivityTimelineSidebarMessage = useSendCrmMessageTopic('OPEN_ACTIVITY_TIMELINE_SIDEBAR');
  const isUngatedForDeprecateLegacyTimeline = useMemo(() => {
    return gates.includes(DEPRECATE_LEGACY_TIMELINE);
  }, [gates]);
  useOnCrmMessageTopic('CLOSE_ACTIVITY_TIMELINE_SIDEBAR', () => {
    const currentLocation = history.location;
    const searchParams = new URLSearchParams(currentLocation.search);
    searchParams.delete('engagement');
    searchParams.delete('type');
    history.replace(Object.assign({}, currentLocation, {
      search: searchParams.toString()
    }));
  });
  useEffect(() => {
    if (isUngatedForDeprecateLegacyTimeline && isEngagementDeepLink && !Array.isArray(query.engagement)) {
      const activityTimelineOptions = {
        prefilterGroups: [{
          filters: [{
            operator: 'EQ',
            property: 'hs_object_id',
            value: query.engagement
          }]
        }],
        timelineId: 'RECORD_TIMELINE',
        objectId: +subjectId,
        objectTypeId,
        prefilterTagsOverrides: {
          hs_object_id: {
            hidden: true
          }
        }
      };
      sendOpenActivityTimelineSidebarMessage(activityTimelineOptions);
    }
  }, [query, sendOpenActivityTimelineSidebarMessage, history, subjectId, objectTypeId, isUngatedForDeprecateLegacyTimeline, isEngagementDeepLink]);
}